var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.8,0h22.5v22.3H149V0h22.5v67.4H149V44.8h-20.6v22.6h-22.5V0L105.8,0z M201.2,22.4h-19.8V0h62.2v22.4h-19.8 v45.1h-22.5L201.2,22.4z M253.4,0h23.5l14.5,23.7L305.8,0h23.5v67.4h-22.4V34l-15.5,24H291l-15.5-24v33.4h-22.1V0L253.4,0z M340.5,0 h22.5v45.1h31.7v22.3h-54.2L340.5,0L340.5,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.9,98.3l32.2,361.6L249.8,500l145.1-40.2l32.3-361.5H72.9z M359.9,184.1l-2,22.5l-0.9,10H250h-0.2h-62.6 l4.1,45.4H250h91h11.9l-1.1,11.9l-10.4,116.7l-0.7,7.5L250,423.2l0,0l-0.2,0.1L159,398.1l-6.2-69.6h44.5l3.2,35.4l49.4,13.3l0,0 l0,0l49.5-13.3l5.1-57.5H250h-0.2h-99.1l-10.9-122.2l-1.1-11.9h111l0,0h111.1L359.9,184.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.35c375580f15ca3b10f429c1a86745b8.svg";
export { ForwardRef as ReactComponent };